export enum RetailMatchMetricLevel {
  Average,
  Comparable,
  Similarity,
}
